import { Confirmation } from "./confirmation";
import { Design } from "./design";
import { DesignList } from "./design-list";
import { DesignModal } from "./design-modal";
import { DesignModalButton } from "./design-modal-button";
import { FormInput } from "./form-input";
import { Select } from "./select";

const install = Vue => {
    Vue.component("confirmation", Confirmation);
    Vue.component("design", Design);
    Vue.component("design-list", DesignList);
    Vue.component("design-modal", DesignModal);
    Vue.component("design-modal-button", DesignModalButton);
    Vue.component("form-input", FormInput);
    Vue.component("select-ripe", Select);
};

export { Confirmation, Design, DesignList, DesignModal, DesignModalButton, FormInput, Select };

export default install;
